(function ($) {
	"use strict";
	$(function () {
		$('#employee-selector-what-do-i-have').on('change',
			function () {
				window.location = $(this).find(':selected').attr('href');
			});
	});
})(jQuery);

